import { render, staticRenderFns } from "./SalesIcon.vue?vue&type=template&id=7dae96ee&"
import script from "./SalesIcon.vue?vue&type=script&lang=js&"
export * from "./SalesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports